"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["light", "isFirst", "isLast", "noInitialConnector", "noEndConnector", "className"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "stepAvatarBullet": "uJwIic",
  "light": "bnGqDS",
  "isFirst": "ACDp2R",
  "noInitialConnector": "Xcp73v",
  "isLast": "L4Kyyi",
  "noEndConnector": "DKtfDj"
};
var StepAvatarBullet = function StepAvatarBullet(_ref) {
  var light = _ref.light,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    noInitialConnector = _ref.noInitialConnector,
    noEndConnector = _ref.noEndConnector,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _clsx["default"])(styles.stepAvatarBullet, light && styles.light, isFirst && styles.isFirst, isLast && styles.isLast, noInitialConnector && styles.noInitialConnector, noEndConnector && styles.noEndConnector, className)
  }, rest));
};
StepAvatarBullet.propTypes = process.env.NODE_ENV !== "production" ? {
  light: _propTypes["default"].bool,
  isFirst: _propTypes["default"].bool,
  isLast: _propTypes["default"].bool,
  noInitialConnector: _propTypes["default"].bool,
  noEndConnector: _propTypes["default"].bool,
  className: _propTypes["default"].string
} : {};
var _default = exports["default"] = StepAvatarBullet;